export const TABLE_ROW_MIN_HEIGHT = 48;
// Not below the 24px horizontal cell inset (12px per side), or a column at the
// minimum has negative content space.
export const TABLE_COL_MIN_WIDTH = 24;

// The Document header ("engagement bar") is fixed over the top of the reader
// viewport, so a sticky row parked at the page scrollport top lands behind it.
// table.scss sets this variable to the bar height only where the bar renders.
export const TABLE_STICKY_TOP_OFFSET = "var(--table-sticky-top-offset, 0px)";
